<template>
    <AdSection1
        :imageSrc="pic1Src"
        title="تبلیغات ویدیویی؛ جذابیت چشمگیر برای مخاطبان"
        :text="`هدف اصلی تبلیغات ویدیویی ایجاد شناخت بصری و عمیق تر برای یک برند در ذهن مخاطب است.</br>
        تبلیغات ویدیویی تاثیرگذاری بهتری نسبت به متن دارند و به شما این امکان را می دهند که به طور مستقیم و جذاب با مخاطبان خود ارتباط برقرار کنید.`"
        imageAnimation="fade-left"
        rowReverse
    >
    </AdSection1>

    <AdSection2
        :imageSrc="pic2Src"
        count="نمایش 5,000,000,000+"
        text="تبلیغ ویدیویی موفق با آن کلیک"
    >
    </AdSection2>

    <AdSection3
        title="تبلیغات ویدیویی"
        text="تبلیغات ویدیویی در بخش های پرمخاطب سایت ها، راهی مؤثر برای نمایش برند، محصولات یا خدمات شماست که نمایش این ویدیوها در زمان و مکان مناسب، شانس دیده شدن و تأثیرگذاری را چندین برابر می کند. با ویدیوهای تبلیغاتی جذاب، همراه با پیام های کوتاه و الهام بخش، می توانید به طور مؤثر توجه کاربران را جلب کرده و آنها را به تعامل با محتوای تبلیغاتی خود ترغیب کنید."
        col
        videoSrc="https://ifilo.net/embed/2IWYxJD"
    >
    </AdSection3>

    <VideoSection4></VideoSection4>

    <VideoSection5></VideoSection5>

    <AdContentCard
        :imageSrc="pic4Src"
        title="تبلیغات ویدیویی مناسب چه کسب و کارهایی است؟"
        text="تبلیغات ویدیویی برای کسب و کارهایی مناسب است که به دنبال جلب توجه سریع مخاطبان و تعامل بیشتر آن ها هستند. این نوع تبلیغات به ویژه برای برندهایی که می خواهند پیام های بصری و تأثیرگذار خود را در کوتاه ترین زمان به مخاطبان هدف برسانند، ایده آل است."
    >
    </AdContentCard>

    <AdTariff
    title="تعرفه تبلیغات ویدیویی"
    text="در آن کلیک، با هر سطح بودجه ای می توانید تبلیغات ویدیویی موثر خود را راه اندازی کنید. هزینه تبلیغات به ازای نمایش می باشد و این امکان را به شما می دهد تا کمپین خود را به خوبی مدیریت کنید."
    :imageSrc="pic5Src"
    >
    </AdTariff>

    <AdRoadmap></AdRoadmap>

    <AdConsult
    text="اگر می خواهید برند خود را از طریق تبلیغات ویدیویی به میلیون ها نفر معرفی کنید، می توانید برای ایجاد کمپین یا دریافت مشاوره تخصصی، با کارشناسان آن کلیک تماس بگیرید."
    >
    </AdConsult>

    <FAQ :faqList="faqList"></FAQ>

</template>

<script>
    import AdSection1 from './AdSection1';
    import AdSection2 from './AdSection2';
    import AdSection3 from './AdSection3';
    import VideoSection4 from './VideoSection4';
    import VideoSection5 from './VideoSection5';
    import AdContentCard from './AdContentCard';
    import AdTariff from './AdTariff';
    import AdRoadmap from './AdRoadmap';
    import AdConsult from './AdConsult';
    import FAQ from './FAQ';

    import videoAdPic1 from '@/assets/images/videoAd-pic1.png';
    import videoAdPic2 from '@/assets/images/videoAd-pic2.png';
    import videoAdPic4 from '@/assets/images/videoAd-pic4.png';
    import videoAdPic5 from '@/assets/images/videoAd-pic5.png';

    import {ref, inject, onMounted} from 'vue';
    export default {
        name: "VideoAds",
    components: {
    AdSection1,
    AdSection2,
    AdSection3,
    VideoSection4,
    VideoSection5,
    AdContentCard,
    AdTariff,
    AdRoadmap,
    AdConsult,
    FAQ,
    },
    setup() {

        const faqList = ref([
        {
            q: "تبلیغات ویدیویی چیست؟",
            a: "تبلیغات ویدیویی نوعی از تبلیغات دیجیتال است که با استفاده از ویدیو، پیام برند یا محصول را به شکلی جذاب و سریع به مخاطبان منتقل می کند."
        },
        {
            q: " تبلیغات ویدیویی برای چه کسب و کارهایی مناسب است؟",
            a: "این نوع از تبلیغات برای کسب و کارهایی مناسب است که به دنبال جذب مخاطب، افزایش تعامل و ارائه پیام های تأثیرگذار در کوتاه ترین زمان هستند."
        },
        {
            q: "تبلیغات ویدیویی در آن کلیک چند نوع است؟",
            a: "تبلیغات ویدیویی در آن کلیک در دو نوع پری رول (قبل از پخش ویدیو) و میدرول (در میان محتوای ویدیویی) نمایش داده می شود."
        },
        {
            q: " هزینه ثبت تبلیغات ویدیویی در آن کلیک چقدر است؟",
            a: `تعرفه تبلیغات ویدیویی به ازای نمایش محاسبه می شود. جزییات بیشتر: <a href="/tariff">تعرفه ثبت تبلیغات</a>`
        },
        {
            q:"برای ثبت تبلیغ ویدیویی در آن کلیک چه کنیم؟",
            a:"در آن کلیک ثبت نام کرده و اولین کمپین خود را ایجاد کنید."
        },
        ]);

        const updateMetaTag = inject('updateMetaTag');
        const updateOGTag = inject('updateOGTag');
        const updateCanonicalLink = inject('updateCanonicalLink');

        onMounted (() => {
            updateMetaTag('title', 'تبلیغات ویدیویی | افزایش تعامل و آگاهی برند با آن کلیک');
            updateMetaTag('description', 'با تبلیغات ویدیویی در آن کلیک، پیام برند خود را در قالب ویدیوهای جذاب به مخاطبان هدف برسانید. بازدهی بالا، نرخ تعامل بیشتر، نمایش در رسانه ای مرتبط.');
            updateOGTag('title', 'تبلیغات ویدیویی | افزایش تعامل و آگاهی برند با آن کلیک');
            updateOGTag('description', 'با تبلیغات ویدیویی در آن کلیک، پیام برند خود را در قالب ویدیوهای جذاب به مخاطبان هدف برسانید. بازدهی بالا، نرخ تعامل بیشتر، نمایش در رسانه ای مرتبط.');
            updateOGTag('type', 'website');
            updateOGTag('image', require('@/assets/images/onclick.png'));
            updateCanonicalLink('https://onclick.ir/ads/video');
        });

        return {
             pic1Src: videoAdPic1,
             pic2Src: videoAdPic2,
             pic4Src: videoAdPic4,
             pic5Src: videoAdPic5,
             faqList,
        }

    }
};
</script>

<style scoped>
</style>